import { useAuth } from "@/context/AuthProvider";
import { PetCardFullScreen } from "@/pages/app/Home/petcard";
import { ArrowLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";

function PetCardPage() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-blue-600 relative">
      {/* Botão de voltar */}
      <button
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 z-10 flex items-center space-x-2 bg-black/20 text-white px-3 py-2 rounded-full hover:bg-black/30 transition-colors"
      >
        <ArrowLeft size={20} />
        <span className="text-sm font-medium">Voltar</span>
      </button>

      {/* PetCard em tela cheia */}
      <PetCardFullScreen
        cardNumber={user?.documento ?? ""}
        ownerName={user?.nome ?? ""}
      />
    </div>
  );
}

export default PetCardPage;